import type { PermissionApi } from '@data-delivery/permission-ui-api';
import { useQuery } from '@tanstack/react-query';
import { permissionQueryClient } from '../../query-client';
import { sftpUsersKeys } from './sftp-users-keys';

/**
 * React Query hook for all visible SFTP users for current platform user.
 * Provides cached list plus helpers for refetch & lookup.
 */
export function useVisibleSftpUsersRQ() {
  const query = useQuery(sftpUsersKeys.visible());
  const users: PermissionApi.UserEntity[] = query.data || [];

  return {
    users,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch() {
      permissionQueryClient.invalidateQueries({ queryKey: sftpUsersKeys.visible().queryKey });
    },
    getById: (id: string) => users.find(u => u.id === id),
  } as const;
}

export default useVisibleSftpUsersRQ;
